import React, { PureComponent } from 'react';
import style from './styles/style.module.css';

import iconFile from 'appSrc/assets/icons/custom/x.svg';

export default class XIcon extends PureComponent {
    render() {
        var inlineStyles = { ...this.props.style };
        if( this.props.size ) {
            inlineStyles.width = inlineStyles.height = this.props.size + 'px';
        }
        return (
            <div className={ `${ this.props.className } ${ style.icon }` } style={ inlineStyles }>
                <img src={ iconFile } alt={ this.props.label }/>
            </div>
        );
    }
}
XIcon.defaultProps = {
    className: '',
    label: 'x icon',
};
